import { Tabs } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import Detail from './Detail';
import './Product.less';

const ALL_TABS = [{ key: 'product_detail', label: 'Барааны дэлгэрэнгүй' }];

const ProductGroupListWithDetail = () => {
  const history = useHistory();
  const location = useLocation();

  const routes = [
    {
      to: {
        pathname: '/merchant/group/product/list',
        search: location.state?.search,
      },
      breadcrumbName: 'Захиалгууд',
    },
    {
      path: 'first',
      breadcrumbName: 'Дэлгэрэнгүй',
    },
  ];

  return (
    <div>
      <PPPageHeader
        title="Багц барааны дэлгэрэнгүй"
        breadcrumb={{ routes }}
        onBack={() =>
          history.push({
            pathname: '/merchant/group/product/list',
            search: location.state?.search,
          })
        }
      />
      <Tabs
        activeKey="product_detail"
        items={ALL_TABS}
        tabBarStyle={{ marginBottom: 0, margin: '0', padding: '0 12px' }}
      />
      <Detail />
    </div>
  );
};

export default ProductGroupListWithDetail;
